import {
    colorBlue500,
    colorBlue600,
    colorGray0,
    colorGray200,
    colorGray300,
} from "@amzn/meridian-tokens/base/color";
import { css } from "@emotion/css";
import styled from "styled-components";


// StatusBadge.styles.ts
import Text from "@amzn/meridian/text";

export const badgeThemes = {
    ACTIVE: {
        background: "#dcf3a0",
        text: "#005c00"
    },
    PENDING: {
        background: "#fff4d9",
        text: "#bf8e00"
    },
    CANCELLED: {
        background: "#f9d5e2",
        text: "#b72346"
    },
    EXPIRED: {
        background: "#f9d5e2",
        text: "#b72346"
    },
    REJECTED: {
        background: "#f9d5e2",
        text: "#b72346"
    },
    default: {
        background: "#e0e0e0",
        text: "#606060"
    }
} as const;

export const BadgeContainer = styled.div<{ status: string }>`
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
    font-size: 14px;
    background-color: ${props =>
            badgeThemes[props.status as keyof typeof badgeThemes]?.background ||
            badgeThemes.default.background};
    color: ${props =>
            badgeThemes[props.status as keyof typeof badgeThemes]?.text ||
            badgeThemes.default.text};
`;

export const StyledDateText = styled(Text)`
    margin-left: 8px;
    color: ${badgeThemes.default.text};
`;



export const buttonMarginStyle = css({
    margin: "7px 0",
});

export const activeStatusBadge = css({
    backgroundColor: "#d1f7c4",
    color: "#2f8a00",
});

export const textEditorStyle = css({
    borderRadius: "7px",
    border: "none",
});

export const createCategoryTextStyle = css({
    padding: "0px 0px 0px 10px",
    display: "inline-block",
});

export const addProductIconStyle = css({
    scale: "0.75",
    verticalAlign: "top",
});

export const createCategoryButtonStyle = css`
  background-color: #e7e9e9;
  color: black;
  justify-content: left;
  margin: -8px -18px;
  height: 22px;
  width: 105%;
  border-radius: 3px;
  padding: 20px;
  &:hover {
    background-color: #004f6c;
    color: #ffffff !important;
  }
`;

export const relativeStyle = css({
    position: "relative",
});

export const colorPalettePopupTopStyle = css({
    bottom: "76%",
    boxShadow: "#d1cdcd 0px 2px 4px 0px inset",
});

export const colorPalettePopupBottomStyle = css({
    top: "74%",
    boxShadow: "lightgrey 0px 5px 5px;",
});

export const colorPaletteStyle = css({
    position: "absolute",
    right: "1px",
    borderRadius: "5px",
    zIndex: 20,
    margin: "0 !important",
    overflow: "auto",
    "&::-webkit-scrollbar": {
        display: "none",
    },
    scrollbarHeight: "none",
    scrollbarWidth: "none",
    backgroundColor: "rgb(255, 255, 255)",
    border: "1px solid rgba(111, 120, 128)",
});

export const colorRadiusStyle = css({
    borderRadius: "50%",
    border: "1px solid #BBC0C1",
});

export const wordBreakStyle = css({
    wordBreak: "break-all",
});

export const borderImageStyle = css({
    border: "1.5px solid #e7e9e9",
    borderRadius: "5px",
});

export const boxStyle = css({
    border: "1px solid #E7E9E9",
    borderRadius: "5px",
    position: "relative",
});

export const imageContainStyle = css({
    objectFit: "contain",
});

export const greenColorStyle = css({
    color: "#47B120",
});

export const mrpStyle = css({
    color: "#585f67",
    fontSize: "14px",
    textDecoration: "line-through",
    padding: "0px 2px",
});

export const editColorStyle = css({
    color: "#077398",
});
export const trashColorStyle = css({
    color: "#CC0C39",
});

export const roundedStyle = css({
    borderRadius: "0px 0px 5px 5px",
});

export const deleteModalAbsoluteStyle = css({
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    borderRadius: "7px",
    border: "2px solid #AD0A30",
});

export const redBackgroundStyle = css({
    backgroundColor: "#AD0A30",
    color: colorGray0,
});

export const cancelButtonStyle = css({
    color: "#DADEE2",
});

export const blueColorStyle = css({
    color: `${colorBlue600} !important`,
});
export const lightGrayColorStyle = css({
    color: `${colorGray300} !important`,
});

export const footerComponentStyle = css({
    position: "sticky",
    bottom: 0,
    left: 0,
    zIndex: 54,
    boxShadow: "0px 2px 16px 0px #0B0C0C1A",
});

export const footerFixedStyle = css({
    position: "fixed",
    bottom: 0,
    left: 0,
    boxShadow: "0px 2px 16px 0px #0B0C0C1A",
    zIndex: 30,
    padding: "12px 16px",
});

export const colorPaletteGridStyle = css({
    display: "grid",
    gridTemplateColumns: "repeat(9, auto)",
    gap: "8px",
});

export const colorPaletteColorWidthStyle = css({
    width: "22px",
    border: "1px solid #BBC0C1",
    transition: "transform 0.3s ease",
    "&:hover": {
        transform: "scale(1.2)",
        zIndex: "10",
    },
});

export const emptyImageContainerStyle = css({
    border: "2px dashed #BBC0C1",
    borderRadius: "5px",
    position: "relative",
});

export const emptyImageContainerInput = css({
    width: "100%",
    minHeight: "100%",
    position: "absolute",
    inset: "0",
    cursor: "pointer",
    opacity: "0",
});

export const plusIconStyle = css({
    fontSize: "28px",
    color: "#BBC0C1",
});

export const uploadImageDeleteStyle = css({
    position: "absolute",
    right: 0,
    backgroundColor: "#fff",
    borderRadius: "50px",
    color: "#232F3E",
});

export const displayFlexStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "inherit",
    width: "inherit",
});

export const bulkUploadTextPadding = css({
    padding: "0px 18.5px",
});

export const bulkUploaderWrapper = css({
    backgroundImage:
        "repeating-linear-gradient(0deg, #077398, #077398 10px, transparent 10px, transparent 21px, #077398 21px), repeating-linear-gradient(90deg, #077398, #077398 10px, transparent 10px, transparent 21px, #077398 21px), repeating-linear-gradient(180deg, #077398, #077398 10px, transparent 10px, transparent 21px, #077398 21px), repeating-linear-gradient(270deg, #077398, #077398 10px, transparent 10px, transparent 21px, #077398 21px)",
    backgroundSize: "2px 100%, 100% 2px, 2px 100% , 100% 2px",
    backgroundPosition: "0 0, 0 0, 100% 0, 0 100%",
    backgroundRepeat: "no-repeat",
    padding: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "3px",
    height: "117px",
});
export const imageStyle = css({
    height: "inherit",
    width: "inherit",
    objectFit: "contain",
});

export const variantsWidthStyle = css({
    width: "30px",
});

export const offerPercentageStyle = css({
    borderRadius: "50%",
});

export const selectedColorBorderStyle = css({
    border: "1.5px solid #077398",
    borderRadius: "50%",
});

export const boarderStyle = css({
    borderTop: "1px solid #BBC0C1",
    borderBottom: "1px solid #BBC0C1",
});

export const uploadImageSelector = css({
    position: "relative",
});

export const selectedImageBorder = css({
    border: "2px solid rgb(0, 104, 141)",
    borderRadius: "7px",
    borderColor: "rgb(0, 104, 141)",
    boxShadow: "0 0 10px rgb(0, 104, 141)",
});

export const uploadImageDelete = css({
    position: "absolute",
    right: 0,
    backgroundColor: "#fff",
    borderRadius: "50px",
    color: "232F3E",
});

export const uploadedImageFile = css({
    width: "inherit",
    height: "inherit",
    objectFit: "contain",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const cropperStyle = css({
    height: "100%",
    width: "100%",
    overflow: "hidden",
});

export const highlightedColorStyle = css({
    backgroundColor: "#8cd3eb",
    padding: "3px 0px",
    borderRadius: "5px",
});

export const cardStyle = css({
    borderRadius: "12px",
    backgroundColor: colorGray0,
});

export const secondaryColorStyle = css({
    color: "#6C7778",
});

export const smallPaddingStyle = css({
    padding: "6px !important",
});

export const nowrapStyle = css({
    whiteSpace: "nowrap",
});

export const collectionImageStyle = css({
    width: "40px",
    height: "40px",
    objectFit: "contain",
    backgroundColor: colorGray0,
});

export const errorColorStyle = css({
    border: "2px solid #e74c3c !important",
});

export const bulkStatusStyle = css({
    borderRadius: "12px 12px 0 0",
});

export const zIndex70 = css({
    zIndex: 70,
});

export const filterMenuRightBorder = css({
    borderRightWidth: "1px",
    borderRightStyle: "solid",
    borderRightColor: colorGray200,
});

export const handleStylePriceSlider = {
    height: 24,
    width: 24,
    marginTop: "-10px",
    border: "2px solid #B9E8F7",
    backgroundColor: "#FAFAFA",
};

export const trackStylePriceSlider = [
    {
        backgroundColor: colorBlue500,
    },
];

export const uamFunctionalityStyle = css({
    color: "#6c7778",
});

export const layoutPaddingStyle = css({
  padding: "20px",
});

export const modalHeaderStyle = css({
  borderBottom: "1px solid #E7E9E9",
  padding: "20px",
});

export const buttonWidthStyle = css({
  width: "198px",
});

export const badgeColorStyle = (status) => css({ 
  color: `${badgeThemes[status].text}`,
});

export const primaryColorStyle = css({
    color: "#232F3E",
})

export const sheetStyle = css({ 
    borderRadius: "12px 12px 0px 0px", 
})

export const sheetBorderStyle = css({ 
    borderBottom: "1px solid #E7E9E9" 
})

export const fullWidthStyle = css({
    width:"100%"
})

export const userCardBorderStyle = css({
    borderBottom: "1px solid #E7E9E9" 
})

export const textPaddingStyles = css({ 
    paddingRight: "6px" 
})

export const roleLineHeightStyles = css({ 
    color: "#949C9C",
    lineHeight: "18px !important"
})

export const inviteLinkStyles = css({
    width:"130px"
})

export const linkIconStyles = css({
    color:"#077398"
})

export const disabledLinkIconStyles = css({
    color:"#90C5D7"
})

export const helpIconStyles = css({
    color:"#6C7778",
    scale:"0.75"
})

export const mobileHelpIconStyles = css({
    color:"#6C7778",
    scale:"0.65"
})

export const centerContentStyle = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: '16px'
});

export const container = css({
  display: 'flex',
  flexDirection: 'column',
//   alignItems: 'center',
  padding: '2rem',
  maxWidth: '650px',
  margin: '0 auto',
});

export const logo = css({
    width: '110px',
    paddingTop: '4rem',
    paddingBottom: '2rem',
})

export const card = css({
  background: 'white',
  borderRadius: '8px',
  padding: '2rem',
  boxShadow: '1px 1px 2px 2px rgba(0,0,0,0.1)',
  width: '100%',
  textAlign: 'center',
  height:'300px'
})

export const footer = css({
    paddingTop: '1rem',
    paddingBottom: '2rem',
    textAlign: 'center',
})

export const storeIcon = css({
  width: '75px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '44px',
  margin: '2rem auto',
  aspectRatio: '1/1',
  fontWeight: "bold",
})

export const pageColor =css({
    background:'#f9fafa',
    minHeight:'100vh'
})

export const FooterClass =css({
    paddingTop:'60px',
    paddingLeft:'60px'
})